import axios from 'axios';

import { SegmentForslag, SegmentForslagNyEnhetQuery, SegmenterPerBransje } from './types';

import { getKjederegAdminApiUrl } from '../../';

const baseUrl = getKjederegAdminApiUrl() + '/segmenter';

export default {
  getSegmenterPerBransje: (): Promise<SegmenterPerBransje> =>
    axios.get(baseUrl).then((response) => response.data),
  getForslag: (enhetId: number): Promise<SegmentForslag> =>
    axios.get(`${baseUrl}/forslag/${enhetId}`).then((response) => response.data),
  getForslagForNyEnhet: (query: SegmentForslagNyEnhetQuery): Promise<SegmentForslag> =>
    axios.get(`${baseUrl}/forslag`, { params: query }).then((response) => response.data),
};
